<template>
  <v-btn text small class="ma-0 pa-2" @click="params.action(params.data)">
    <v-icon>{{ params.icon }}</v-icon>
  </v-btn>
</template>

<style lang="scss" scoped>
@import "buttonRenderer.scss";
</style>

<script type="text/javascript">
import Vue from "vue";
export default Vue.extend({
  computed: {},
  data() {
    return {};
  },
  methods: {}
});
</script>
